import { formatCountText } from "~/utils/strings";

export const formatDaysAhead = (days: number): string => {
  if (days === 0) {
    return "today";
  }
  return formatCountText(days, "day");
};

type EntityClientOnboardingCaseMap = {
  isInvestingProfile?: boolean | null;
};

export const isEntityClientOnboardingProfile = (
  complianceCases?: ReadonlyArray<EntityClientOnboardingCaseMap | null> | null,
): boolean => (complianceCases ?? []).some((caseMap) => caseMap?.isInvestingProfile === true);
